import React from "react";

import Button from "src/components/app/Button";
import { getBlurDataURL } from "src/helpers/common";
import Image from "../common/Image";
import { LucideArrowRight } from "lucide-react";

interface HeroBannerProps {
  image: string;
  onButtonClick: () => void;
  mode: string;
}

const HeroBanner: React.FC<HeroBannerProps> = ({
  image,
  onButtonClick = null,
  mode,
}) => {
  return (
    <div className="flex flex-col relative w-full">
      <Image
        src={image}
        alt="Welcome Image"
        className="h-full"
        priority
        objectFit="cover"
        objectPosition="center"
        width={390}
        height={640}
        style={{
          position: "relative",
          zIndex: 2,
        }}
        blurDataURL={getBlurDataURL(image)}
      />
      {onButtonClick && mode !== "view_only" && (
        <div className="px-4 absolute w-full z-10 text-center top-[87%]">
          <Button
            onClick={onButtonClick}
            variant="contained"
            size="lg"
            fullWidth
          >
            <div className="flex flex-row items-center justify-center gap-2">
              <span>Join the Program</span>
              <LucideArrowRight />
            </div>
          </Button>
        </div>
      )}
    </div>
  );
};

export default HeroBanner;
